module.exports = __webpack_public_path__ + "images/fa-homepage-hero-image.webp";